import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//高校合作
export function collegesListApi() {
  return _collegesListApi.apply(this, arguments);
}
//培训商合作
function _collegesListApi() {
  _collegesListApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", useGet('/web/collegesList'));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _collegesListApi.apply(this, arguments);
}
export function enterpriseListApi() {
  return _enterpriseListApi.apply(this, arguments);
}
function _enterpriseListApi() {
  _enterpriseListApi = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", useGet('/web/enterpriseList'));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _enterpriseListApi.apply(this, arguments);
}